import { Button } from "@/components/ui/button";
import { formatEuro } from "./helpers";
import { StepHeader } from "./ProgressBar";

function SummaryRow({ label, value, highlight }) {
  return (
    <div className="flex justify-between items-center px-5 py-4">
      <span className="text-[13px] uppercase tracking-[0.05em] font-semibold text-oc-textSecondary">{label}</span>
      <span className={`font-${highlight ? "mono font-semibold" : "medium"} text-oc-primary text-[15px]`}>
        {value || "—"}
      </span>
    </div>
  );
}

const PAYMENT_METHODS = ["Bancontact", "iDEAL", "Visa", "Mastercard", "Apple Pay", "Google Pay"];

export default function StepBetaling({
  type,
  regio,
  email,
  bundle,
  discountInfo,
  baseAmountCents,
  appliedDiscount,
  finalAmountCents,
  submitting,
  handlePay,
}) {
  return (
    <div className="max-w-xl mx-auto space-y-8 animate-[fade-in-up_500ms_ease-out_both]">
      <StepHeader sub="Na betaling start de analyse onmiddellijk.">
        Bijna klaar — veilig betalen
      </StepHeader>

      <div className="bg-white rounded-oc border border-oc-border divide-y divide-oc-border">
        <SummaryRow label="Type offerte" value={type} />
        <SummaryRow label="Regio" value={regio} />
        <SummaryRow label="Rapport naar" value={email} />
        <SummaryRow label="Pakket" value={bundle ? "3-pack bundle (3 credits)" : "Eén analyse"} />
        {discountInfo?.valid && (
          <>
            <SummaryRow label="Subtotaal" value={`€ ${formatEuro(baseAmountCents)}`} />
            <SummaryRow
              label={`Kortingscode (${discountInfo.percent_off}%)`}
              value={`-€ ${formatEuro(appliedDiscount)}`}
            />
          </>
        )}
        <SummaryRow
          label="Totaal"
          value={`€ ${formatEuro(finalAmountCents)} incl. 21% BTW`}
          highlight
        />
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        {PAYMENT_METHODS.map((m) => (
          <div
            key={m}
            className="py-3 px-2 rounded-oc-btn bg-white border border-oc-border text-center text-[12px] font-semibold text-oc-textSecondary"
          >
            {m}
          </div>
        ))}
      </div>

      <Button
        data-testid="pay-button"
        disabled={submitting}
        onClick={handlePay}
        className="w-full h-14 rounded-oc-btn bg-oc-primary hover:bg-oc-secondary text-white text-[16px] font-semibold transition-all hover:scale-[1.01] disabled:opacity-50"
      >
        {submitting ? "Bezig met doorsturen..." : `Betaal € ${formatEuro(finalAmountCents)} en start analyse`}
      </Button>
      <p className="text-center text-[13px] text-oc-textSecondary">
        Je wordt doorgestuurd naar de beveiligde betaalpagina van MultiSafepay.
      </p>
    </div>
  );
}
